var render, staticRenderFns
import script from "./listLogisticVariant.vue?vue&type=script&lang=js&"
export * from "./listLogisticVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed5ee3b8')) {
      api.createRecord('ed5ee3b8', component.options)
    } else {
      api.reload('ed5ee3b8', component.options)
    }
    
  }
}
component.options.__file = "src/app/logisticVariant/logisticVariant/components/list/listLogisticVariant.vue"
export default component.exports